
import * as types from '../types';

export const getPriceRule = (canteenId) => ({
    type: types.GET_PRICE_RULES,
    payload: { canteenId },
});

export const getPriceRuleSuccess = (priceRuleData) => ({
    type: types.GET_PRICE_RULES_SUCCESS,
    payload: priceRuleData,
});

export const getPriceRuleError = (error) => ({
    type: types.GET_PRICE_RULES_ERROR,
    payload: error,
});

export const addPriceRule = (priceRuleData, priceRuleId, callback) => ({
    type: types.ADD_PRICE_RULE,
    payload: { priceRuleData, priceRuleId, callback },
});

export const addPriceRuleSuccess = (success, message) => ({
    type: types.ADD_PRICE_RULE_SUCCESS,
    payload: { success, message },
});

export const addPriceRuleError = (error) => ({
    type: types.ADD_PRICE_RULE_ERROR,
    payload: error,
});

export const assignTenants = (priceRuleId, tenants, callback) => ({
    type: types.ASSIGN_TENANTS,
    payload: { priceRuleId, tenants, callback },
});

export const assignTenantsSuccess = (success, message, tenants, priceRuleId) => ({
    type: types.ASSIGN_TENANTS_SUCCESS,
    payload: { success, message, tenants, priceRuleId },
});

export const assignTenantsError = (error) => ({
    type: types.ASSIGN_TENANTS_ERROR,
    payload: error,
});

export const getPriceRuleDetails = (priceRuleId) => ({
    type: types.GET_PRICE_RULE_DETAILS,
    payload: { priceRuleId },
});

export const getPriceRuleDetailsSuccess = (priceRuleDetails) => ({
    type: types.GET_PRICE_RULE_DETAILS_SUCCESS,
    payload: priceRuleDetails,
});

export const getPriceRuleDetailsError = (error) => ({
    type: types.GET_PRICE_RULE_DETAILS_ERROR,
    payload: error,
});

export const deletePriceRule = (priceRuleId, canteenId, callback) => ({
    type: types.DELETE_PRICE_RULE,
    payload: { priceRuleId, canteenId, callback },
});

export const deletePriceRuleSuccess = (success, message, priceRuleId) => ({
    type: types.DELETE_PRICE_RULE_SUCCESS,
    payload: { success, message, priceRuleId },
});

export const deletePriceRuleError = (error) => ({
    type: types.DELETE_PRICE_RULE_ERROR,
    payload: error,
});

export const getGuestDiscountsByCategory = (canteenId) => ({
    type: types.GET_GUEST_DISCOUNTS_BY_CATEGORY,
    payload: { canteenId },
});

export const getGuestDiscountsByCategorySuccess = (guestDiscounts) => ({
    type: types.GET_GUEST_DISCOUNTS_BY_CATEGORY_SUCCESS,
    payload: guestDiscounts,
});

export const getGuestDiscountsByCategoryError = (error) => ({
    type: types.GET_GUEST_DISCOUNTS_BY_CATEGORY_ERROR,
    payload: error,
});

export const getCategoriesByGuestDiscount = (canteenId) => ({
    type: types.GET_CATEGORIES_BY_GUEST_DISCOUNT,
    payload: { canteenId },
});

export const getCategoriesByGuestDiscountSuccess = (categories) => ({
    type: types.GET_CATEGORIES_BY_GUEST_DISCOUNT_SUCCESS,
    payload: categories,
});

export const getCategoriesByGuestDiscountError = (error) => ({
    type: types.GET_CATEGORIES_BY_GUEST_DISCOUNT_ERROR,
    payload: error,
});